import type { DashboardHealthResponse } from '@frontend/types/adminhub';
import type { DashboardOverviewResponse } from '@frontend/pages/dashboard/types';
import type { EcosystemProject } from '@frontend/types';

async function authJson<T>(path: string, token: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init?.headers || {}),
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error((data as { message?: string }).message || `Request failed: ${response.status}`);
  }
  return data as T;
}

export async function fetchDashboardOverview(token: string): Promise<DashboardOverviewResponse> {
  return authJson<DashboardOverviewResponse>('/api/dashboard/overview', token);
}

export async function fetchProjectsForEcosystem(
  ecosystemId: string,
  token: string,
): Promise<EcosystemProject[]> {
  const data = await authJson<{ projects?: EcosystemProject[] }>(
    `/api/projects?ecosystem=${encodeURIComponent(ecosystemId)}`,
    token,
  );
  return data.projects || [];
}

export async function fetchAdminProjectsCreateScope(token: string): Promise<unknown> {
  return authJson('/api/admin/projects/create-scope', token);
}

export async function fetchDashboardHealth(token: string): Promise<DashboardHealthResponse> {
  return authJson<DashboardHealthResponse>('/api/dashboard/health', token);
}
